/**
 * 날짜 포맷을 위한 Format strings
 */
export const TimeFormat = {
    /**
     * 기본형식
     * @example '12/25(금요일)'
     */
    'MM/dd(EEEE)': 'MM/dd(EEEE)',
    /** '12/25(금)' */
    'MM/dd(E)': 'MM/dd(E)',
    /** '12.25(금)' */
    'MM.dd(E)': 'MM.dd(E)',
    /** '2/1' */
    'M/d': 'M/d',
    /** '02/01' */
    'MM/dd': 'MM/dd',
    /**
     * digit clock style
     * @example '23:59'
     */
    'HH:mm': 'HH:mm',
    /** @example '5.24.(수) */
    'M.d.(EEE)': 'M.d.(EEE)',
    /** @example '5.24.(수) 07시 */
    'M.d.(EEE) HH': 'M.d.(EEE) HH',
    /** @example '5. 24.(수) */
    'M. d.(EEE)': 'M. d.(EEE)',
    /**
     * 월,일 숫자 표기 > 문장 내에서 사용 시
     * @example '5. 24. (수)'
     */
    'M. d. (EEE)': 'M. d. (EEE)',
    /** @example 1. 24.(금) 19:54 */
    'M. d.(EEE) HH:mm': 'M. d.(EEE) HH:mm',
    /** @example 2. 1.  */
    'M. d.': 'M. d.',
    /** @example 3월 4일 */
    'M월 d일': 'M월 d일',
    /** @example 3월 4일(월) */
    'M월 d일(E)': 'M월 d일(E)',
    /** @example 3월 4일 (월) */
    'M월 d일 (EEE)': 'M월 d일 (EEE)',
    /** @example 3월 4일 (월) */
    'M월 d일 (EEE) HH:mm': 'M월 d일 (EEE) HH:mm',
    /** @example 3 4 6 */
    'M d h': 'M d h',
} as const

export type TimeFormatType = Constant<typeof TimeFormat>

export const DateFormat = {
    /** @example '2021.08.20' */
    'yyyy.MM.dd': 'yyyy.MM.dd',
    'MM. dd.': 'MM. dd.',
    /** @example 04. 15. (월) */
    'MM. dd. (EEE)': 'MM. dd. (EEE)',
    /** @example '2024. 04. 05'
     * 스튜디오 디자인가이드 참고
     * @see https://wiki.fin.navercorp.com/pages/viewpage.action?pageId=116057358
     */
    'yyyy. MM. dd.': 'yyyy. MM. dd.',
    /** @example '2021.08.20 17:08' */
    'yyyy.MM.dd HH:mm': 'yyyy.MM.dd HH:mm',
    /** @example '2023.11.14 12:55:12 221 */
    'yyyy.MM.dd HH:mm:ss SSS': 'yyyy.MM.dd HH:mm:ss SSS',
    /** @example '3.13 06:20' */
    'M.d. HH:mm': 'M.d. HH:mm',
    'M.d.': 'M.d.',
    /** @example 2024.03.28 12:55:12 */
    'yyyy.MM.dd HH:mm:ss': 'yyyy.MM.dd HH:mm:ss',
    /** @example 2024.03.28. 12:55:12 */
    'yyyy.MM.dd. HH:mm:ss': 'yyyy.MM.dd. HH:mm:ss',
    /** @example 2024. 03. 28. 22:55:12 */
    'yyyy. MM. dd. HH:mm:ss': 'yyyy. MM. dd. HH:mm:ss',
    /** @example 24-04 */
    'yy-MM': 'yy-MM',
    /** @example 2024-04 */
    'yyyy-MM': 'yyyy-MM',
    /** @example 2024-04-05 */
    'yyyy-MM-dd': 'yyyy-MM-dd',
    /** @example 2024-11-07 19:24:00 */
    'yyyy-MM-dd HH:mm:ss': 'yyyy-MM-dd HH:mm:ss',
    /** @example 2024년 04월 08일 */
    'yyyy년 MM월 dd일': 'yyyy년 MM월 dd일',
    /** @example 04월 08일 */
    'MM월 dd일': 'MM월 dd일',
    /** @example 04월 08일 (월) */
    'MM월 dd일 (EEE)': 'MM월 dd일 (EEE)',
    /** @example 2024.04.15(월) */
    'yyyy.MM.dd(EEE)': 'yyyy.MM.dd(EEE)',
    /** @example 2024. 04. 15. (월) */
    'yyyy. MM. dd. (EEE)': 'yyyy. MM. dd. (EEE)',
    /** @example 2018-09-14T23:59:59 (ISO-8601) */
    "yyyy-MM-dd'T'HH:mm:ss": "yyyy-MM-dd'T'HH:mm:ss",
    /** @example 20241031 */
    yyyyMMdd: 'yyyyMMdd',
} as const

export type DateFormatType = Constant<typeof DateFormat>

export const YearUnit = {
    ONE: 1,
    FIVE: 5,
} as const

export const TimeUnit = {
    SECONDS: 1000,
    MINUTES: 60000,
} as const
